/**
 * Provera adrese servera — parserom, ne regularnim izrazom.
 *
 * Ranije je ovde stajao ručno pisan izraz koji je tražio bar jednu tačku, pa je
 * odbijao `localhost`, `mojserver` i imena Docker/Kubernetes servisa, a
 * `127.0.0.1` propuštao — ne zato što razlikuje IP od imena, nego zato što IP
 * slučajno ima tačke. Bio je istovremeno prestrog tamo gde ne treba i preslab
 * tamo gde je važno.
 *
 * Pravi sud ionako pada kasnije: `ValidateServerUrlActivity` na backendu
 * parsira adresu i zove `get_info` nad njom, pa registraciju propušta samo živ
 * inery čvor. Ovde treba odbaciti očiglednu besmislicu pre nego što se ide na
 * mrežu — ništa više.
 */

/** Ima li adresa svoj scheme (`http://`, `https://`, `ftp://`…). */
const IMA_SCHEME = /^[a-zA-Z][a-zA-Z\d+.-]*:\/\//;

export function testURL(url) {
  const s = String(url ?? "").trim();
  if (!s) return false;

  // Bez scheme-a `new URL` čita `localhost:8888` kao protokol `localhost:` i
  // praznu putanju, pa se dopisuje podrazumevani. Adresa sa svojim scheme-om se
  // ne dira — da bi `ftp://` pao na proveri protokola, a ne prošao neopaženo.
  const puna = IMA_SCHEME.test(s) ? s : `http://${s}`;

  try {
    const u = new URL(puna);
    return (u.protocol === "http:" || u.protocol === "https:") && u.hostname.length > 0;
  } catch {
    return false;
  }
}
